const ICON_SCALE = 1.25;
const ICON_Y_AXIS_MARGIN = 4;

interface IconPosition {
  iconY: number;
  iconRight: number;
}

interface CalculateIconPositionProps {
  idx: number;
  iconHeight: number;
  iconWidth: number;
  insightIconTop: number;
  insightIconRight: number;
  yOffsetCount: number;
  minIconY?: number;
}

export const calculateIconPosition = ({
  idx,
  iconHeight,
  iconWidth,
  insightIconTop,
  insightIconRight,
  yOffsetCount,
  minIconY = 0,
}: CalculateIconPositionProps): IconPosition => {
  const iconOffsetY = (yOffsetCount + idx) * iconHeight * ICON_SCALE;
  const calculatedY =
    insightIconTop - iconHeight - ICON_Y_AXIS_MARGIN - iconOffsetY;
  const iconY = Math.max(minIconY, calculatedY);
  const iconRight = insightIconRight - iconWidth / 2;

  return { iconY, iconRight };
};
